import cx from 'classnames'
import styles from './AnswerEditorBodyErrorHint.module.css'

export interface AnswerEditorBodyErrorHintProps {
  id?: string
  errors?: string[]
  /**
   * Test ID attribute for the error hint.
   */
  testId?: string
}

/**
 * Renders an error hint for the answer editor body.
 */
export function AnswerEditorBodyErrorHint({
  id,
  errors,
  testId,
}: AnswerEditorBodyErrorHintProps) {
  // We don't want the hint element to take up space if there's no content to
  // display.
  const isRendered = errors?.length !== null
  return (
    <div
      id={id}
      className={cx(styles.root, !isRendered && styles.hidden)}
      aria-live="polite"
      data-test={testId}
    >
      {!errors?.length ? null : errors.length === 1 ? (
        errors[0]
      ) : (
        <>
          Please fix the following errors:
          <ul className={styles.errorList}>
            {errors.map((msg, idx) => (
              <li key={idx}>{msg}</li>
            ))}
          </ul>
        </>
      )}
    </div>
  )
}
